import { PORT_ADDRESSES, Ports } from "freight/constants/Ports";

export const getDrayagePortFromAddress = (zip: string): Ports | undefined =>
  Object.values(Ports).find((port) => PORT_ADDRESSES[port].zip === zip);
